<template>
  <v-form ref="formStepGenericBreakdown" v-model="formStepGenericBreakdownValid" @submit.prevent="submit">
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-xl mt-4" :border="false" :elevation="0">
          <v-row>
            <v-col cols="12">
              <h1>{{ $t('FILE_STEP_BREAKDOWN.TITLE') }}</h1>
            </v-col>
            <v-col cols="12">
              <p require-field="true">{{ $t('FILE_STEP_BREAKDOWN.DESCRIPTION') }}</p>
              <v-textarea
                v-model.trim="description"
                :placeholder="$t('FILE_STEP_BREAKDOWN.PLACEHOLDER.DESCRIPTION')"
                :rules="requiredRules"
                auto-grow
                rows="3"
                :error-messages="error?.description"
                :maxlength="150"
                :counter="150"
              />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" class="d-flex justify-start">
        <v-btn
          :disabled="!formStepGenericBreakdownValid || loading"
          :loading="loading"
          class="pl-15 pr-15"
          :class="!formStepGenericBreakdownValid || loading ? 'boom-button-transparent' : 'boom-button'"
          type="submit"
          variant="outlined"
        >
          {{ $t('COMMON.BUTTON.CONTINUE') }}
          <img
            alt="arrow_small-icon"
            :class="!formStepGenericBreakdownValid || loading ? 'arrow-black-svg' : 'arrow-white-svg'"
            src="@/assets/icons/file/arrow_small_right.svg"
          />
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import RepairFileService from '@/services/RepairFileService'
import { auth as $store } from '@/store/AuthModule'
import { handleResponseError } from '@/components/utils/globalFunction'
import ResponseConstant from '@/constants/responseConstant'
import { RepairFile } from '@/models/RepairFile'
import Validator from '@/components/utils/validator'
import RepairFileStatusDetailConstant from '@/constants/repairFileStatusDetailConstant'

export default {
  name: 'StepGenericBreakdownPage',
  props: {
    currentStep: Number,
    currentRepairFile: {
      type: RepairFile,
      default: null
    }
  },
  data() {
    return {
      error: null,
      loading: false,
      formStepGenericBreakdownValid: false,
      description: null,
      requiredRules: Validator.requiredRules
    }
  },
  mounted() {
    this.patchRepairFile()
  },
  methods: {
    async patchRepairFile() {
      if (this.currentRepairFile.breakdown_description) {
        this.description = this.currentRepairFile.breakdown_description
      }
    },
    async submit() {
      const formattedData = {
        status_detail: RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED,
        is_complete_update: true,
        breakdown_description: this.description,
        requestor_collaborator_id: $store.state.currentCollaborator.technical_id
      }

      try {
        const formData = new FormData()
        formData.append('data', JSON.stringify(formattedData))
        await RepairFileService.update(this.currentRepairFile.technical_id, formData)

        this.$emit('change-step', this.currentStep + 1)
      } catch (error) {
        handleResponseError(error)
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          this.setError(error.response.data.key)
        }
      }
    },
    async updatePartialData() {
      const formattedData = {
        status_detail: RepairFileStatusDetailConstant.BREAKDOWN_EVALUATED,
        breakdown_description: this.description,
        requestor_collaborator_id: $store.state.currentCollaborator.technical_id
      }
      try {
        const formData = new FormData()
        formData.append('data', JSON.stringify(formattedData))
        await RepairFileService.update(this.currentRepairFile.technical_id, formData)
      } catch (error) {
        handleResponseError(error)
      }
    },
    setError(key) {
      switch (key) {
        case 'invalid_breakdown_description_error_key':
          this.error = { description: this.$t('ERROR.' + ResponseConstant[key]) }
          break
        default:
          this.error = ''
      }
    }
  }
}
</script>

<style scoped>
.v-card {
  padding: 24px;
}

.v-form p {
  margin-bottom: 16px;
}

.arrow-black-svg {
  height: 100%;
  width: 50%;
  filter: invert(0%) sepia(35%) saturate(13%) hue-rotate(154deg) brightness(96%) contrast(100%);
}

.arrow-white-svg {
  height: 100%;
  width: 50%;
  filter: invert(100%) sepia(0%) saturate(1%) hue-rotate(209deg) brightness(109%) contrast(101%);
}

.boom-button-transparent:hover .arrow-svg {
  filter: invert(48%) sepia(35%) saturate(7492%) hue-rotate(64deg) brightness(105%) contrast(79%);
}
</style>
